<div class="box-file"
    [class.disabled]="disabled"
    nbSpinnerStatus="info"
    [nbSpinner]="disabled"
    *ngIf="!file.isCatalog">
    <div class="box-file__name" *ngIf="!previewBlocksEnabled">
        <nb-checkbox [(checked)]="selected" *ngIf="!previewBlocksEnabled && multiSelect"
            (checkedChange)="selectedChange.next($event)"></nb-checkbox>

        <nb-icon icon="file-outline"></nb-icon>
        
        {{ file.name }}

        <div class="box-file__tooltip" *ngIf="!previewBlocksEnabled && infoTemplate && displayType !== displayTypes.LIST_PREVIEW">
            <nb-icon icon="info-outline"
                [nbPopover]="infoTemplate"
                [nbPopoverContext]="file"
                nbPopoverTrigger="hint"
                nbPopoverPlacement="top"></nb-icon>
        </div>
    </div>
    
    <ng-container *ngIf="previewBlocksEnabled; else detailsTemplate">
        <div class="box-file__info">
            <div class="info__title">
                <div class="title__date">
                    {{file.date | date : "dd LLLL yyy"}}
                </div>
                <div class="title__avatar" *ngIf="file.owner">
                    <app-user-avatar [userFullName]="file.owner"></app-user-avatar>
                </div>
            </div>
            <div class="info__preview">
                <ng-container *ngIf="previewTemplate">
                    <ng-container *ngTemplateOutlet="previewTemplate; context: { $implicit: file }"></ng-container>
                </ng-container>
    
                <img *ngIf="!previewTemplate" [src]="file.preview" appImgFallback alt="roboze-photo" />
            </div>
            <div class="info__fileSize">
                {{file.size | fileSize}}
            </div>
        </div>
        
        <div class="box-file__fileName" [class.pb-0]="infoTemplate">
            {{file.name}}
        </div>
        
        <div class="box-file__information" *ngIf="infoTemplate">
            <ng-container *ngTemplateOutlet="infoTemplate; context: { $implicit: file }"></ng-container>
        </div>
        
        <div class="box-file__actions">
            <span class="action action--danger"
                *ngIf="enableDelete && !this.file.isFixed"
                (click)="onDelete.next(file)"
                [nbTooltip]="'device.files.delete-file' | translate">
                <nb-icon icon="trash-2-outline"></nb-icon>
            </span>
            <span class="action" *ngIf="enableUnlock" (click)="onUnlock.next(file)">
                <nb-icon icon="unlock-outline"></nb-icon>
            </span>
            <span class="action"
                *ngIf="enableShare" (click)="onShare.next(file)"
                [nbTooltip]="'device.files.share-file' | translate">
                <nb-icon icon="share-outline"></nb-icon>
            </span>
            <span class="action" *ngIf="enableDownload"
                [nbTooltip]="'device.files.download-file' | translate"
                (click)="onDownload.next(file)">
                <nb-icon icon="download-outline"></nb-icon>
            </span>
            <span class="action action--primary action--print"
                [nbTooltip]="'device.files.print-file-title' | translate"
                (click)="onPrint.next(file)"
                *ngIf="enablePrint && file.isAvailableToPrint">
                <nb-icon icon="play-circle-outline"></nb-icon>
            </span>
        </div>
    </ng-container>

    <!-- PREVIEW  -->
    <div class="box-file__list-information" *ngIf="infoTemplate && displayType === displayTypes.LIST_PREVIEW">
        <ng-container *ngTemplateOutlet="infoTemplate; context: { $implicit: file }"></ng-container>
    </div>
</div>

<div class="box-catalog cursor-pointer"
    [class.disabled]="disabled"
    nbSpinnerStatus="info"
    [nbSpinner]="disabled"
    *ngIf="file.isCatalog"
    click-stop-propagation
    (click)="onNext.next(file)">
    <div class="box-catalog__name">
        <nb-checkbox *ngIf="!previewBlocksEnabled && multiSelect" [(checked)]="selected" 
            (checkedChange)="selectedChange.next($event)" click-stop-propagation></nb-checkbox>

        <nb-icon icon="folder-outline"></nb-icon>
        {{file.name}}
    </div>
    <div class="box-catalog__actions" *ngIf="previewBlocksEnabled; else detailsTemplate">
        <span class="action" *ngIf="enableShare"
            [nbTooltip]="'device.files.share-file' | translate"
            (click)="onShare.next(file)" click-stop-propagation>
            <nb-icon icon="share-outline"></nb-icon>
        </span>
        <span class="action action--danger"
            (click)="onDelete.next(file)"
            [nbTooltip]="'device.files.delete-file' | translate"
            *ngIf="enableDelete && !this.file.isFixed" click-stop-propagation>
            <nb-icon icon="trash-2-outline"></nb-icon>
        </span>
    </div>
</div>

<ng-template #detailsTemplate>
    <div class="details">
        <span *ngIf="enableShare" click-stop-propagation (click)="onShare.next(file)">
            <nb-icon icon="share-outline"></nb-icon>
        </span>
    
        <div class="details__avatar" *ngIf="file.owner">
            <app-user-avatar [userFullName]="file.owner"></app-user-avatar>
        </div>
    
        <span
            *ngIf="actions.length && displayType === displayTypes.LIST"
            tabindex="-1"
            click-stop-propagation
            nbContextMenuTrigger="click"
            [nbContextMenuTag]="componentID + '-' + file.id"
            [nbContextMenuPlacement]="placement"
            [nbContextMenu]="actions"
            (blur)="hideMenu()"
            (click)="switchMenu()">
            <nb-icon icon="more-horizontal-outline"></nb-icon>
        </span>

        <div class="details__file-size" *ngIf="displayType === displayTypes.LIST">
            <ng-container *ngIf="!file.isCatalog">
                {{file.size | fileSize}}
            </ng-container>
        </div>

        <div class="details__date" *ngIf="displayType !== displayTypes.LIST_PREVIEW">
            {{file.date | date : "dd.MM.yyy"}}
        </div>

        <span class="action action--primary action--print d-flex align-items-center"
            [nbTooltip]="'device.files.print-file-title' | translate"
            (click)="onPrint.next(file)"
            *ngIf="enablePrint && file.isAvailableToPrint && displayType === displayTypes.LIST_PREVIEW">
            <nb-icon icon="play-circle-outline"></nb-icon>
        </span>
    </div>
</ng-template>